import { Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';
import { MarketDataService } from '../market-data.service';

@Component({
  selector: 'crypto-modify',
  standalone: false,
  templateUrl: './modify.component.html',
  styleUrl: './modify.component.scss'
})
export class CryptoModifyComponent implements OnInit, OnDestroy {

  @ViewChild('modifyForm', { static: true }) modifyForm: NgForm | undefined
  errorMessage!: string
  loadingMarketData = false

  public crypto: any

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CryptoModifyComponent>,
    private currencyPipe: CurrencyPipe,
    private marketData: MarketDataService
  ) {
    console.error('CryptoModifyComponent -> constructor', data)
    this.crypto = data
  }

  ngOnInit(): void {
    console.error('CryptoModifyComponent -> ngOnInit')

    if (this.crypto.usdBrl == undefined || this.crypto.btcUsd == undefined)
      this.loadMarketData()

    //Update total
    this.modifyForm?.valueChanges?.subscribe((input:any) => {
      // console.error('CryptoCreateComponent -> modifyForm.valueChanges', 'amount', input['crypto.amount'], 'price', input['crypto.price'], 'tax', input['crypto.tax'])

      if(input['crypto.amount'] != undefined && input['crypto.price'] != undefined && input['crypto.tax'] != undefined )
        this.crypto.total = ((parseFloat(input['crypto.amount']) * parseFloat(this.currencyPipe.transform(input['crypto.price'], false))) + parseFloat(this.currencyPipe.transform(input['crypto.tax'], false))).toFixed(2)
    })
  }

  // Operations created before the quotes existed get them from the operation date
  async loadMarketData(): Promise<void> {
    const date = this.crypto.date?.seconds != undefined ? new Date(this.crypto.date.seconds * 1000) : this.crypto.date
    if (!date) return

    this.loadingMarketData = true
    const [usdBrl, btcUsd] = await Promise.all([this.marketData.getUsdBrl(date), this.marketData.getBtcUsd(date)])
    this.crypto.usdBrl = usdBrl
    this.crypto.btcUsd = btcUsd
    this.loadingMarketData = false
  }

  ngOnDestroy(): void {
    console.warn('CryptoModifyComponent -> ngOnDestroy')
  }

  onSubmit(): void {
    console.error('CryptoModifyComponent -> onSubmit', this.modifyForm?.value)

    if (this.modifyForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Crypto modified!',
          values: { 
            ...this.crypto, 
            amount: parseFloat(this.modifyForm.value['crypto.amount']), 
            price: parseFloat(this.currencyPipe.transform(this.modifyForm.value['crypto.price'], false)),
            tax: parseFloat(this.currencyPipe.transform(this.modifyForm.value['crypto.tax'], false)),
            total: parseFloat(this.currencyPipe.transform(this.modifyForm.value['crypto.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
